var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSouthEast = function SvgSouthEast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.233 20.005 8.18 9.953a1 1 0 0 1 0-1.414l.353-.353a1 1 0 0 1 1.414 0L20 18.236V9.755a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v12.75H9.75a1 1 0 0 1-1-1v-.5a1 1 0 0 1 1-1h8.483Z"
  })));
};
export default SvgSouthEast;